import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const AdminAccounts = lazy(() => import('./AdminAccounts'))

const AdminAccountsRoutes = [
    {
        path: '/admin_accounts',
        component: AdminAccounts,
        auth: authRoleAccess.adminOnly,
    },
]

export default AdminAccountsRoutes 